import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />
);

reportWebVitals();

serviceWorkerRegistration.register();

